<template>
  <div id="headerArea">
    <header id="l_header">
      <div class="header_inner">
        <div class="nav01">
          <a href="https://www.lawson.co.jp/id/" class="lid">
            <img
              style="vertical-align: baseline;"
              alt
              title
              src="https://www.lawson.co.jp/common2015/img/logo_lawson_id.png"
            />
          </a>
          <ul class="list01">
            <li class="item01">
              <a href="https://www.lawson.co.jp/lab/app/">アプリ</a>
            </li>
            <li class="item02">
              <a href="https://www.lawson.co.jp/lab/tsuushin/art/1360089_4659.html">メルマガ</a>
            </li>
            <li class="item03">
              <a href="http://store.lawson.co.jp/" target="_blank">店舗･ATM検索</a>
            </li>
            <li class="item04">
              <a href="https://www.lawson.co.jp/newstore/">新店情報</a>
            </li>
            <li class="item05">
              <a href="https://www.lawson.co.jp/faq/">お問い合わせ</a>
            </li>
          </ul>
          <ul class="list02">
            <li>
              <a href="https://www.lawson.co.jp/company/ir/">IR</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/company/activity/">社会･環境</a>
            </li>
            <li>
              <a target="_blank" href="https://www.lawson.co.jp/company/fc/">オーナー募集</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/company/branch/">物件募集</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/company/recruit/">採用情報</a>
            </li>
          </ul>
        </div>

        <div class="nav02">
          <a href="https://www.lawson.co.jp/index.html" class="logo">
            <img
              src="https://www.lawson.co.jp/common2015/img/logo_lawson.png"
              width="140"
              height="21"
              alt="コンビニエンスストア「ローソン」"
            />
          </a>
          <ul>
            <li>
              <a href="https://www.lawson.co.jp/recommend/index.html">商品･おトク情報</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/campaign/index.html">エンタメ･キャンペーン</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/ponta/index.html">ポイントカード</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/service/">サービス</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/lab/">研究所</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/netshopping/">ご予約商品</a>
            </li>
            <li>
              <a href="https://www.lawson.co.jp/company/">会社情報</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "HeaderItem"
};
</script>
<style>
</style>

